import React from 'react';
import { CONSTANTES } from '../../utils/Constantes';

const Radio = ({titulo, onChange, value, opciones, clase="", tipo, validate}) => 
<div>
    <p className={clase} >{titulo}</p>
    <div style={tipo=='horizontal'?{display:"flex"}:{}} className={validate?'':'input-error'}>
    { opciones.map((item, i) => 
      <div key={i} style={{margin: "2px 6px"}}>
        <label>
          <input className="with-gap" name={item.name} checked={value===(item.value+ CONSTANTES.SEPARADOR+item.detalle)?"checked": ""} value={item.value + CONSTANTES.SEPARADOR + item.detalle} onChange={(e) => onChange(e)}  type="radio"  />
          <span className={"span-radio"} style={value===(item.value+ CONSTANTES.SEPARADOR+item.detalle)?{color: "#494F66"}:{}}>{item.detalle}</span>
        </label>
      </div>
      )      
    }
    </div>
</div>

export default Radio;